<template>
  <div
    class="floor-box"
    :class="{ current: current }"
    :style="index == 0 ? 'margin-top: 3px;' : ''"
    @click="changeCurrent()"
  >
    <div class="handel-box">
      <div
        class="up-icon"
        v-show="index != 0"
        @click.stop="upFloor(index)"
      ></div>
      <div
        class="down-icon"
        v-show="index != floorCount - 1"
        @click.stop="downFloor(index)"
      ></div>
      <div class="del-icon" @click.stop="delFloor(index)"></div>
    </div>
    <div class="floor-content">
      <div class="header-box" v-show="item.name">
        <p class="floor-name">{{ item.name }}</p>
      </div>
      <ul class="nav-list">
        <li
          class="nav-li"
          v-for="(item2, index) in item.contentList"
          :key="index"
        >
          <img v-if="item2.navImg" :src="item2.navImg" alt="" class="nav-img" />
          <div class="nav-name">
            {{ item2.navName }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mFloorHandle from "../../../mixin/m-floor-handle";
import numberHandler from "../../../mixin/numberHandle";
export default {
  name: "ShopCenterAdminWebMFloorArticle",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    current: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    floorCount: {
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {
    shopId() {
      return this.$store.state.user.userInfo.shopId;
    },
  },
  mounted() {},
  mixins: [mFloorHandle, numberHandler],
  methods: {
    // 选中楼层
    changeCurrent() {
      this.$emit("selectFloor", {
        id: 206,
        index: this.index,
        key: this.item.key,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.floor-box {
  position: relative;
  // height: 110px;
  padding: 15px;
  margin-top: 5px;
  border: 1px solid transparent;
  cursor: pointer;
  &:hover {
    background: #fff;
    border: 1px dashed #197dff;
    border-radius: 6px;
    border-top-right-radius: 0;
    box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
    .handel-box {
      display: flex;
    }
  }
  .handel-box {
    display: none;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    top: -1px;
    right: -30px;
    width: 28px;
    padding-top: 15px;
    border-radius: 0px 5px 5px 0px;
    border-top: 1px dashed #197dff;
    border-right: 1px dashed #197dff;
    border-bottom: 1px dashed #197dff;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(191, 191, 191, 0.25);
    .up-icon {
      width: 13px;
      height: 10px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/up-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        background: url(../../../assets/images/pc-decoration/up-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .down-icon {
      width: 13px;
      height: 10px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/down-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      &:hover {
        background: url(../../../assets/images/pc-decoration/down-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
    .del-icon {
      width: 10px;
      height: 12px;
      margin-bottom: 15px;
      background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
        no-repeat;
      background-size: 100% 100%;
      cursor: pointer;

      &:hover {
        background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .floor-content {
    // width: 100%;
    // height: 100%;
    padding: 10px 15px;
    // background: #fff;
    border-radius: 8px;
    .header-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .floor-name {
        color: #333;
        font-size: 17px;
        font-weight: 500;
        line-height: 17px;
      }
    }
    .nav-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      .nav-li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // height: 65px;
        padding: 5px 7px;
        margin-right: 12px;
        margin-bottom: 10px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(5),
        &:nth-child(6),
        &:nth-child(7),
        &:nth-child(8) {
          margin-bottom: 0;
        }
        .nav-img {
          width: 40px;
          height: 40px;
          margin-bottom: 12px;
          border-radius: 8px;
        }
        .nav-name {
          width: 55px;
          height: 13px;
          color: #3a3d4b;
          font-size: 13px;
          line-height: 13px;
          text-align: center;
        }
      }
    }
  }
}
.current {
  background: #fff;
  border: 1px dashed #197dff;
  border-radius: 6px;
  border-top-right-radius: 0;
  box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
  .handel-box {
    display: flex;
  }
}
</style>
